export default __webpack_public_path__ + "static/orange_tree-2e6df79aeff613bbc7d818a05af36a84.png";